import type { TEmailSendResponseDTO } from './emailSends.dto';

import type { TEmailSendResult } from './emailSends.types';

const toEmailSendResult = (dto: TEmailSendResponseDTO): TEmailSendResult => ({
  sendID: dto.send_id,
  status: dto.status,
  error: dto.error,
});

export {
  toEmailSendResult,
};
